import { currencyColumn, dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn, textColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'default';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    textColumn({column: 'name', label: 'Name', required: true}),
    textColumn({column: 'description', label: 'Description'}),
    textColumn({column: 'location', label: 'Location'}),
    dateColumn({column: 'training_date', required: true}),
    relationshipColumn({column: 'attendees', label: 'Attendees', endpoint: 'contacts', multiple: true, hydrate: false}),
];

const TrainingsHeld = forwardRef(function TrainingsHeld(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {TrainingsHeld};
